const breakpoints = {
  breakpointHero: 1500,
  breakpointDesktop: 1100,
  breakpointMedium: 800,
  breakpointSmall: 500,
  breakpointMini: 360
};

export default breakpoints;